<template>
  <div class="person-swiper-box">
    <el-carousel indicator-position="outside" arrow="never" height="33.68rem">
      <el-carousel-item v-for="(item, index) in swiperList" :key="index">
        <div class="person-swiper-wrap">
          <div
            class="person-swiper-item"
            v-for="(personItem, personIndex) in item"
            :key="personIndex"
          >
            <div class="person-icon-box">
              <img
                :src="getImgUrl(personItem.thumb)"
                class="icon hvr-grow"
                alt=""
              />
            </div>
            <div class="title">{{ personItem.title }}</div>
            <div class="swiper-text" v-html="personItem.content"></div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { pageApi } from "@/api";
import _ from "lodash";
export default {
  props: {
    teamList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    swiperList() {
      return _.chunk(this.teamList, 4);
    },
  },
  methods: {
    getPerson(index) {
      return require(`@/assets/team/person${index}.png`);
    },
    getName(index) {
      switch (index) {
        case 1:
          return "史红霞";
        case 2:
          return "刘明魁";
        case 3:
          return "张华超";
        case 4:
          return "刘晨";
      }
    },
    getText(index) {
      switch (index) {
        case 1:
          return "战略合作伙伴";
        case 2:
          return "技术合伙人";
        case 3:
          return "技术合伙人";
        case 4:
          return "高级PHP工程师";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
